import React                            from 'react';
import { Observe }                      from 'rewire-core';
import {
  IActionMenuItem,
  WithStyle,
  withStyles,
}                                       from 'rewire-ui';
import LogIcon                          from '@material-ui/icons/AssignmentOutlined';
import DeleteIcon                       from '@material-ui/icons/DeleteOutlined';
import { useWatch }                     from '../settings/SettingsModel';
import employeeEditorViewTabs           from '../settings/EmployeeEditorViewTabs';
import employeeViewTypeModel,
{
  IEmployeeViewType,
}                                       from '../settings/EmployeeViewTypeModel';
import { EmployeeEditorContentsView }   from '../settings/EmployeeEditorView';
import { Theme }                        from '../utility/styles';
import infoPanelEmployeeViewModel       from './InfoPanelEmployeeViewModel';
import Loader                           from '../ui/Loader';
import InfoPanelHeader                  from '../ui/InfoPanelHeader';
import InfoPanelContent                 from '../ui/InfoPanelContent';
import InfoPanelFooter                  from '../ui/InfoPanelFooter';
import ArchiveDeleteEmployeeDialog      from '../settings/ArchiveDeleteEmployeeDialog';

const styles = (_theme: Theme) => ({
});

interface IInfoPanelEmployeeViewProps {
  classes?: any;
}

type InfoPanelEmployeeViewProps = WithStyle<ReturnType<typeof styles>, IInfoPanelEmployeeViewProps>;

class InfoPanelEmployeeView extends React.Component<InfoPanelEmployeeViewProps> {
  optionsActionMenuItems: IActionMenuItem[];

  constructor(props: InfoPanelEmployeeViewProps) {
    super(props);

    this.optionsActionMenuItems = [
      { name: 'deleteEmployee', title: 'Delete Employee', icon: DeleteIcon, onClick: infoPanelEmployeeViewModel.deleteEmployee,     closeOnClick: true, disabled: () => !infoPanelEmployeeViewModel.canDelete || !infoPanelEmployeeViewModel.employee },
      { name: 'auditLog',       title: 'View Audit Log',  icon: LogIcon,    onClick: infoPanelEmployeeViewModel.loadAuditLogDialog, closeOnClick: true, disabled: () => !infoPanelEmployeeViewModel.employee },
    ];
  }

  componentWillUnmount() {
    infoPanelEmployeeViewModel.reset();
  }

  handleViewButtonClick = (view: IEmployeeViewType) => () => {
    employeeViewTypeModel.view = view;
  };

  renderEmployeeInfo = React.memo((): JSX.Element => {
    useWatch(
      () => {
        employeeViewTypeModel.view;
      },
      async () => {
        infoPanelEmployeeViewModel.isLoading = true;
        await infoPanelEmployeeViewModel.loadView();
        infoPanelEmployeeViewModel.isLoading = false;
      }
    );

    return <Observe render={() => {
      const jobId              = infoPanelEmployeeViewModel.jobId;
      const hasEmployee        = infoPanelEmployeeViewModel.hasEmployee;
      const headerTitle        = !jobId                 ? 'No employee for unsaved job' : !hasEmployee ? 'No employee assigned to this job' : `Employee: ${infoPanelEmployeeViewModel.employee!.name}`;
      const headerTabs         = !hasEmployee           ? undefined                     : employeeEditorViewTabs;
      const headerOptionsTitle = !jobId || !hasEmployee ? ''                            : 'Employee Options';
      const headerOptionsItems = !jobId || !hasEmployee ? undefined                     : this.optionsActionMenuItems;
      return (
        < >
          <InfoPanelHeader title={headerTitle} tabs={headerTabs} optionsMenuTitle={headerOptionsTitle} optionsMenuTooltip={headerOptionsTitle} optionsItems={headerOptionsItems} />
          {!hasEmployee
            ? null
            : <Observe render={() => (
                <Loader loading={infoPanelEmployeeViewModel.isLoading}>
                  <InfoPanelContent>
                    <EmployeeEditorContentsView model={infoPanelEmployeeViewModel} />
                  </InfoPanelContent>
                </Loader>
              )} />

          }
          {hasEmployee && <Observe render={() => <InfoPanelFooter isDisabled={infoPanelEmployeeViewModel.isDisabled} actions={infoPanelEmployeeViewModel.footerActions} /> } />}
        </>
      );
    }} />;
  });

  render() {
    return <Observe render={() => (
      < >
      <this.renderEmployeeInfo />
      <ArchiveDeleteEmployeeDialog />
      </>
    )} />;
  }
}

export default withStyles<IInfoPanelEmployeeViewProps,unknown>(styles, InfoPanelEmployeeView);
